module.exports = __webpack_public_path__ + "img/zeca-icon-simple.8aaac6bb.svg";